import React, {Component} from 'react'

class Loading extends Component {
  render() {
    return (
      <div className="box_loading">
        <span className="ico_blog ico_loading">로딩중입니다.</span>
      </div>
    )
  }
}

export default Loading
